import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  root: {
    display: 'flex',
    backgroundcolor: '#000000',
  },
  circleBar: {
    position: 'fixed',
    textAlign: 'center',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: '8000',

    backgroundColor: '#000',
    MozOpacity: '0.2',
    filter: 'alpha(opacity=20)',
    opacity: '0.2',
  },
  circle: {
    position: 'fixed',
    textAlign: 'center',
    top: '200px',
    left: 'calc(50% - 50px)',
    width: '100px',
    zIndex: '9000',
  }
});

class Loading extends React.Component {

  render() {
    const { classes, isRequest } = this.props;
    return (
      <div>
        {(isRequest) &&
          <div className={classes.root}>
            <CssBaseline />
            <div className = { classes.circleBar }></div>
            <CircularProgress size='10' className = { classes.circle }/>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isRequest: state.common.isRequest,
});

const mapDispatchToProps = {};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(Loading))
);
